import React, { useState } from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { formatDate, formatReceiptDate } from "../../../utils/formatNocDate";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@store/store";
import {
  fetchApplicationDetailsRow,
  fetchbankguaranteedetailsThunk,
  fetchpadetailsThunk,
  fetchReceiptDetailsThunk,
} from "../redux/thunk/application-detailThunk";
import { useLocation } from "react-router-dom";
import { FeesDetailsThunk } from "@modules/application-section/application-details/redux/services/thunk/DetailsThunk";
import dayjs from "dayjs";
import ROWProvisionalFinalAgreement from "./ROWProvisionalFinalAgreement";

const ROWProvisionalFinal = ({
  feeDatails,
  roDetails,
  userData,
  public_demand_signed_at,
}: any) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const params = new URLSearchParams(location.search);
  const row = params.get("row");
  const access = params.get("access");
  const [esignCompleted, setEsignCompleted] = useState(false);
  const [applicantdata, setapplicantData] = React.useState<any>(null);
  const [esignTmpURL, setEsignTmpURL] = React.useState<any>(null);
  const { profile } = useSelector((state: RootState) => state.profile);
  const [bgDetails, setBGDetails] = React.useState<any>(null);
  const [paDetails, setPADetails] = React.useState<any>(null);
  const [getFeesDetails, setGetFeesDetails] = React.useState<any>(null);
  const [feeDetails, setFeeDetails] = React.useState<any>(null);
  const totalAmount = Array.isArray(feeDetails)
    ? feeDetails?.[0]?.fees?.totalAmount
    : feeDetails?.fees?.totalAmount;
  React.useEffect(() => {
    if (row) {
      fetchROW(row);
    }
  }, [row]);

  // const fetchROW = async (id: any) => {
  //   try {
  //     const res = await dispatch(fetchApplicationDetailsRow(id)).unwrap();
  //     setapplicantData(res);
  //   } catch (error) {
  //     console.error("Error fetching ROW details:", error);
  //   }
  // };

  const fetchROW = async (id: any) => {
    try {
      const res = await dispatch(fetchApplicationDetailsRow(id)).unwrap();
      // If the id is inside res.data, set applicantdata to res.data
      setapplicantData(res);
    } catch (error) {
      console.error("Error fetching ROW details:", error);
    }
  };

  React.useEffect(() => {
    if (applicantdata && applicantdata?.application_id) {
      dispatch(
        fetchbankguaranteedetailsThunk(applicantdata?.application_id),
      ).then((res: any) => {
        if (res.payload) {
          setBGDetails(res.payload);
        }
      });
    }
  }, [applicantdata?.application_id, dispatch]);

  React.useEffect(() => {
    if (applicantdata && applicantdata?.application_id) {
      dispatch(fetchpadetailsThunk(applicantdata?.application_id)).then(
        (res: any) => {
          if (res.payload) {
            setPADetails(res.payload);
          }
        },
      );
    }
  }, [applicantdata?.application_id, dispatch]);

  React.useEffect(() => {
    const fetchFeesAmount = async () => {
      if (applicantdata?.application_id) {
        try {
          const feesAmount = await dispatch(
            FeesDetailsThunk({ applicationId: applicantdata?.application_id }),
          ).unwrap();
          setGetFeesDetails(feesAmount || {});
        } catch (error) {
          console.error("Error fetching Fees details:", error);
        }
      }
    };
    fetchFeesAmount();
  }, [applicantdata?.application_id, dispatch]);

  React.useEffect(() => {
    if (applicantdata?.application_id) {
      dispatch(fetchReceiptDetailsThunk(applicantdata?.application_id)).then(
        (res: any) => {
          if (res.payload?.success && Array.isArray(res.payload.data)) {
            setFeeDetails(res.payload.data);
          }
        },
      );
    }
  }, [applicantdata?.id || applicantdata?.application_id]);

  return (
    <>
      <style>
        {`
          .pdf-document,
          .pdf-document * {
            box-sizing: border-box;
          }

          .pdf-document {
            width: 100%;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            color: #000;
          }

          .pdf-document img {
            max-width: 100%;
            height: auto;
          }

          .pdf-document p,
          .pdf-document li,
          .pdf-document div,
          .pdf-document span {
            overflow-wrap: break-word;
          }

          .pdf-document .html2pdf__page-break,
          .pdf-document .pdf-page-break {
            display: block !important;
            break-before: page !important;
            page-break-before: always !important;
            break-inside: auto !important;
            page-break-inside: auto !important;
          }

          @media print {
            @page {
              size: A4;
              margin: 8mm 10mm;
            }

            html,
            body {
              margin: 0 !important;
              padding: 0 !important;
              height: auto !important;
              overflow: visible !important;
            }

            .pdf-document {
              width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              color: #000 !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .pdf-document * {
              color: #000 !important;
            }

            .pdf-page-break {
              break-before: page !important;
              page-break-before: always !important;
            }
          }
        `}
      </style>
      <Box
        className="pdf-document"
        sx={{
          p: { xs: 1, md: 4 },
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          margin: "0 auto",
          textAlign: "justify",
          fontSize: 18,
          lineHeight: 1.45,
          color: "#000",
          fontFamily: "Trebuchet MS, Arial, sans-serif",

          overflow: "visible",
          height: "auto",
          minHeight: 0,

          "& *": {
            fontFamily: "Trebuchet MS, Arial, sans-serif",
            boxSizing: "border-box",
          },

          "@media print": {
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            padding: "8mm 10mm",
            fontSize: "14px",
            lineHeight: 1.45,
            color: "#000",
            overflow: "visible",
            height: "auto",
            minHeight: 0,

            "& *": {
              color: "#000 !important",
              fontFamily: "Trebuchet MS, Arial, sans-serif",
            },
          },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, md: 4 },
            borderRadius: 3,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            height: "auto",
            minHeight: 0,
            overflow: "visible",

            "@media print": {
              boxShadow: "none",
              borderRadius: 0,
              padding: 0,
              margin: 0,
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              minHeight: 0,
              overflow: "visible",
            },
          }}
        >
          {/* Header */}
          <img
            src={require("@assets/images/national-emblem.png")}
            alt="National Emblem"
            style={{
              display: "block",
              margin: "0 auto",
              width: 60,
              height: "auto",
            }}
          />
          <Typography
            variant="h6"
            fontWeight={700}
            align="center"
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Government of India
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Ministry of Road Transport & Highways
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Regional Office - {roDetails?.office_name || "_"}
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 400,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            {roDetails?.address_line1}
          </Typography>
          {/* <Typography align="center" sx={{ fontWeight: 400, fontSize: "inherit" }}>
          Phone No. {roDetails?.contact_number || "____"}, Email-
          {roDetails?.email ? (
            <a href={`mailto:${roDetails.email}`}>{roDetails.email}</a>
          ) : (
            "____"
          )}
        </Typography> */}
          <Divider sx={{ my: 2 }} />
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              mb: 1,
              textDecoration: "underline",
              textAlign: {
                xs: "right",
                md: "right",
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              },
            }}
          >
            PROVISIONAL NOC
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Application No.: <b>{applicantdata?.application_code || "___"}</b>
            </Typography>
            <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Dated: {formatDate(new Date().toISOString())}
            </Typography>
          </Box>
          {/* To Section */}
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            To,
            <br />
            {/* {userData?.name || "_____"},
          <br /> */}
            {userData?.organizations?.[0]?.business_name || "____"},
            <br />
            {userData?.organizations?.[0]?.city_name || "____"},&nbsp;
            {userData?.organizations?.[0]?.district_name || "____"},&nbsp;
            {userData?.organizations?.[0]?.state_name || "____"},
            <br />
            {userData?.organizations?.[0]?.pincode || "__"}
          </Typography>

          {/* Subject */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Subject:</b> Permission for accommodation of{" "}
            <b>{applicantdata?.amenity}</b>{" "}
            <b>{applicantdata?.proposed_utility_alignment},&nbsp;</b>
            <b>{applicantdata?.national_highway_number}</b>. : regarding issue
            of Final NOC.
          </Typography>
          {/* Body */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Respected Sir/Mam,
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;Please refer to your application id{" "}
            <b>{applicantdata?.application_code || "<id No>"}</b> dated{" "}
            <b>{formatDate(applicantdata?.created_at) || "<date>"}</b>{" "}
            submitting therewith proposal for accommodation of subject cited
            utility services for approval of this office.
            <br />
            2. The licensee fee submission as submitted by{" "}
            <b>
              {userData?.organizations?.[0]?.business_name ||
                "<organization name>"}
            </b>{" "}
            has been received by the Government. Further 30 days comment period
            ended on <b>{public_demand_signed_at}</b> and this office has not
            received any comments during/ after the expiry of the period
            stipulated in the Ministry’s guidelines i.e, one month, from the
            public.
            <br />
            3. You have proposed for Proposal of permission for{" "}
            <b>
              {(applicantdata && applicantdata?.amenity) || "……………………………. "}
            </b>
            , which have also been recommended by the{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {" - "}
            <b>{paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}</b> .
            You have submitted requisite license fees of ₹{" "}
            <b>{totalAmount ?? "0"}</b> through Bharatkosh Portal dated{" "}
            <b>
              {" "}
              {feeDetails?.[0]?.transactionDate &&
                formatReceiptDate(feeDetails?.[0]?.transactionDate)}
            </b>{" "}
            (Transaction Ref No- <b>{feeDetails?.[0]?.transactionId || "NA"}</b>
            ).
            <br />
            4. Based on the drawings, checklist and associated documents as
            recommended by the{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {" - "}
            <b>{paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}</b> ,
            the Permission for use of Highway Land is hereby granted by the{" "}
            <b>{roDetails?.office_name || "____"}</b> {"-"}{" "}
            <b>{applicantdata?.ca_authority}</b> , on behalf of the Highway
            Administration as per details indicated in the approved drawing and
            the conditions stipulated below in the license deed. A signed copy
            of the license deed is enclosed for necessary action. This license
            deed for the instant Utility Service is valid for 5 years from the
            date of issue of this permission. On the expiry of lease, the
            permission may be renewed by the Highway Administration on payment
            of applicable renewal fee, if it conforms to the stipulated norms of
            the Ministry. The Utility Service provider shall apply, with all the
            documents, for renewal at least four months before the expiry of
            license deed. The Permission is being issued to the proposal,
            subject to the following general conditions:
          </Typography>

          {/* General Conditions */}
          <Box
            component="ol"
            sx={{
              pl: 3,
              mb: 2,
              fontSize: "inherit",
              lineHeight: 1.45,
              listStyleType: "none",
              counterReset: "item",

              // Let long conditions flow naturally between PDF pages.
              breakInside: "auto",
              pageBreakInside: "auto",
              overflowWrap: "break-word",
              wordBreak: "normal",

              "& > li": {
                counterIncrement: "item",
                lineHeight: 1.45,
                marginBottom: "4px",
                breakInside: "auto",
                pageBreakInside: "auto",
                overflowWrap: "break-word",
                wordBreak: "normal",

                "&::before": {
                  content: '"4." counter(item) " "',
                  fontWeight: "normal",
                  marginRight: "0.5em",
                },
              },
            }}
          >
            <li>
              The accommodation of proposed utility shall be strictly as per the
              Ministry’s letter No. RW/NH-33044/29/2015/S&R(R) dated 22.11.2016
              and as per the details indicated in the approved
              sketches/drawings. No change in the alignment of other than
              approved herein will be entertained. Any deviation may result in
              cancelling of the permission/approval.
            </li>
            <li>
              The applicant will be authorized to install/laying of the utility
              services as per approved methodology and drawings within the NH
              RoW only after signing of the agreement.
            </li>
            <li>
              The proposed laying operation of utility shall be in such a manner
              that it causes least interference to the traffic movement and also
              traffic safety.
            </li>
            <li>
              RoW permissions are only enabling in nature. The purpose of
              extending the way leave facility on the National Highway RoW is
              not for enhancing the scope of activity of a utility service
              provider, either by content or by intent. Further, enforceability
              of the permission so granted shall be restricted only to the
              extent of provisions/scope of activities defined in the license
              agreement for the purpose for which it is granted.
            </li>
            <li>
              No Licensee shall claim exclusive right on the RoW and any
              subsequent user will be permitted to use the RoW, either above or
              below, or by the side of the utilities laid by the first user,
              subject to technical requirements being fulfilled. Decision of the
              Authority in relation to fulfilment of technical requirements
              shall be final and binding on all concerned parties. In case any
              disruption/damage is caused to any existing user by the subsequent
              user, the Authority shall not be held accountable or liable in any
              manner.
            </li>
            <li>
              The Licensee shall be responsible for undertaking all activities
              including, but not limited to site identification, survey, design,
              engineering, arranging finance, project management, obtaining
              regulatory approvals & necessary clearances, supply of equipment,
              material, construction, erection, testing and commissioning,
              maintenance and operation and all other activities essential or
              required for efficient functioning of their own utility /
              industrial infrastructure facilities.
            </li>
            <li>
              License Fee shall have to be paid in advance for the period for
              which permission is granted for entering into a license agreement.
              In case of renewal, rate prevailing at the time of renewal shall
              be charged. Delay in renewal and deposition of fee shall attract
              interest @ 15% per annum compounded annually.
            </li>
            <li>
              The utility service shall be permitted to cross the National
              Highway either through structure or conduits specially built for
              those purposes. The casing / conduit pipe should, as minimum,
              extend from drain to drain in cuts and toe of slope to toe of
              slope in the fills and shall be designed in accordance with the
              provision of IRC and executed following the Specifications of the
              Ministry. The Existing drainage structures shall not be allowed to
              carry the lines across. The Licensee shall ensure making good the
              excavated trench for laying utility services by proper filling and
              compaction, so as to restore the land in to the same condition as
              it was before digging the trench, clearing debris/loose earth
              produced due to execution of trenching at least 50 m away from the
              edge of the right of way.
            </li>
            <li>
              <u>
                {" "}
                All required restoration works subsequent to laying of the
                Utility shall be required to be undertaken by the Licensee at
                its own cost either by itself or through its authorized
                representative in consultation with the Authority (The concerned
                Executive Engineer of NH Division Ahmedabad as per predetermined
                time schedule and quality standards).
              </u>
            </li>
            <li>
              <b>
                {" "}
                <u>
                  {" "}
                  Prior to commencement of any work on the ground, a Performance
                  Bank Guarantee of amount ₹{" "}
                  <b>{getFeesDetails?.BankGuarantee || "___"}</b> as specified
                  by the{" "}
                  {Array.isArray(paDetails) && paDetails.length > 0 && (
                    <b>
                      {paDetails.map((pa: any) => pa.office_name).join(" / ")}
                    </b>
                  )}{" "}
                  {" - "}
                  <b>
                    {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
                  </b>
                  . as per MoRTH circular dated 22.11.2016 with a validity of
                  one year initially (extendable if required till satisfactory
                  completion of work) shall have to be furnished by the Licensee
                  to the Authority/its designated agency ({" "}
                  {Array.isArray(paDetails) && paDetails.length > 0 && (
                    <b>
                      {paDetails.map((pa: any) => pa.office_name).join(" / ")}
                    </b>
                  )}{" "}
                  {" - "}
                  <b>
                    {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
                  </b>{" "}
                  .) as a security against improper restoration of ground in
                  terms of filling/unsatisfactory compaction damages caused to
                  other underground installations/utility services interference,
                  interruption, disruption or failure caused thereof to any
                  services etc. In case of the Licensee failing to discharge the
                  obligation of making good of the excavated trench/other
                  restoration work, the Authority shall have a right to make
                  good the damages caused by excavation, at the cost of the
                  Licensee and recover the amount by for feature of the Bank
                  Guarantee.
                </u>{" "}
              </b>
            </li>
            <li>
              <u>
                {" "}
                In case, the electronic Performance Bank Guarantee (e-PBG) is
                invoked as mentioned above, the Licensee shall be required to
                replenish and reinstate the required electronic Performance Bank
                Guarantee (e-PBG) within one month of such invoking. In case the
                work contemplated herein is not completed to the satisfaction of
                the Authority, which has granted the permission, within a period
                of 11 months from the date of issue of the Bank Guarantee, the
                Licensee shall either furnish a fresh guarantee or extend the
                guarantee for a further period of one year. Notwithstanding
                this, the Licensee shalt be liable to pay full compensation to
                the aggrieved Authority / its designated agency for any damage
                sustained by them by reason of the exercise of the RoW facility.
              </u>
            </li>
            <li>
              <b>
                <u>
                  The Licensee shall shift the utility services within 90 days
                  on own cost (or as specified by the respective Authority) from
                  the date of issue of the notice by the concerned Authority to
                  shift/ relocate the utility services, in case it is so
                  required for the purpose of improvement/widening of the
                  road/route/highway or construction of flyover/bridge and
                  restore the road/land to its original condition at his own
                  cost and risk.
                </u>
              </b>
            </li>
            <li>
              The Licensee shall be responsible to ascertain from the respective
              agency in co-ordination with Authority, regarding the location of
              other utilities / underground installations/facilities etc. The
              Licensee shall ensure the safety and security of already existing
              underground installations/utilities/facilities etc. before
              commencement of the excavation/using the existing cable ducts. The
              Licensee shall procure insurance from a reputed insurance company
              against damages to already existing underground
              installations/utilities/facilities etc.
            </li>
            <li>
              <u>
                {" "}
                The Licensee shall be solely responsible/liable for full
                compensation/indemnification of concerned agency/aggrieved
                Authority for any direct, indirect or consequential damage
                caused to them/claims or replacements sought for, at the cost
                and risk of the Licensee. The concerned agency in co-ordination
                with Authority shall also have a right make good such
                damages/recover the claims by forfeiture of Bank Guarantee.
              </u>
            </li>
            <li>
              Three copies of 'as laid drawings' of utilities (hard and soft
              copies) with geotagged photographs and geo-tagged video recordings
              of laying of cables in the trench (with respect to the NH) and
              after complete restoration shall be submitted to the Authority for
              verification and submitting their recommendation for issuing the
              Final NOC by Highway Administration for making utility
              operational.
            </li>
            <li>
              <b>
                {" "}
                The Utility Services shall not be made operational by the
                Licensee unless a final approval is obtained from the Highway
                Administration without which the concerned Executive Engineer
                will not release the submitted electronic Performance Bank
                Guarantee (e-PBG).
              </b>
            </li>
            <li>
              For PPP Projects, in case of any financial loss incurred by the
              respective project concessionaires due to such laying/shifting of
              utility services by the Licensee, compensation for the same shall
              be required to be borne by the Licensee in mutual agreement with
              the respective project concessionaires. MoRT&H Implementing
              Authorities for the project shall not be liable to the
              concessionaire in any way in this regard.
            </li>
          </Box>
          <Box sx={{ height: "12px" }} />
          <Typography
            sx={{
              mb: 0,
              fontSize: "inherit",
              lineHeight: 1.45,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              breakInside: "avoid",
              pageBreakInside: "avoid",
            }}
          >
            <b>Special Instructions of Approval:</b>
          </Typography>
          <Box
            component="div"
            sx={{
              pl: 0,
              mb: 2,
              fontSize: "inherit",
              lineHeight: 1.45,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              overflowWrap: "break-word",
              wordBreak: "normal",
              breakInside: "auto",
              pageBreakInside: "auto",
            }}
          >
            {applicantdata?.ca_provisional_remarks?.comments} at{" "}
            {formatDate(applicantdata?.ca_provisional_remarks?.created_at)}
          </Box>

          {/* Special Conditions */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
              width: "100%",
              marginTop: "24px",
              marginBottom: "20px",
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",

              // Keep the signature/enclosure block together when possible.
              breakInside: "avoid",
              pageBreakInside: "avoid",
              overflow: "visible",

              "@media print": {
                marginTop: "16px",
                marginBottom: "16px",
              },
            }}
          >
            <Box
              sx={{
                textAlign: "left",
                minWidth: 0,
                flex: "1 1 auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "4px",
                  minWidth: 0,
                  overflowWrap: "break-word",
                }}
              >
                <Box>Encl:</Box>
                <Box>
                  (i) Signed License deed.
                  <br />
                  (ii) Approved Drawings
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                textAlign: "right",
                flex: "0 1 48%",
                minWidth: 0,
                overflowWrap: "break-word",
                wordBreak: "normal",
              }}
            >
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "inherit",
                  lineHeight: 1.45,
                  fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                }}
                align="right"
              >
                Yours faithfully,
              </Typography>

              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "inherit",
                  lineHeight: 1.45,
                  fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                }}
                align="right"
              >
                {roDetails?.ro_name} {"-"} {roDetails?.office_name || "__"}{" "}
                {"-"} <b>{applicantdata?.ca_authority}</b>
                <br />
                Regional Officer / Executive Director
                <br />
                For Highway Administration
                <br />
                (Digitally signed)
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              lineHeight: 1.45,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              overflowWrap: "break-word",
              wordBreak: "normal",
              breakInside: "auto",
              pageBreakInside: "auto",
            }}
          >
            <b>Copy to:</b>
            <br />
            <b>
              1.{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>
                  {paDetails?.map((pa: any) => pa?.office_name).join(" / ")}
                </b>
              )}{" "}
              {" - "}
              <b>
                {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
              </b>{" "}
              {applicantdata?.is_legacy && (
                <span>for information and necessary actions.</span>
              )}
              {!applicantdata?.is_legacy && (
                <>
                  With request to keep original Bank guarantee vide BG no:&nbsp;
                  <b>{bgDetails?.bank_guarantee_no || "___"}</b> dated{" "}
                  <b>{formatDate(bgDetails?.bg_isssue_date || "___")}</b> valid
                  up to{" "}
                  <b>{formatDate(bgDetails?.bg_validity_date || "___")}</b> from
                  Bank <b>{bgDetails?.bg_bank_name || "___"} </b> in your safe
                  custody.
                </>
              )}
            </b>
          </Typography>
        </Paper>
        <div
          className="pdf-page-break html2pdf__page-break"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            margin: 0,
            padding: 0,
            breakBefore: "page",
            pageBreakBefore: "always",
          }}
        >
          <ROWProvisionalFinalAgreement
            feeDetails={feeDetails}
            applicantdata={applicantdata}
            roDetails={roDetails}
            bgDetails={bgDetails}
            paDetails={paDetails}
            getFeesDetails={getFeesDetails}
            userData={userData}
          />
        </div>
      </Box>
    </>
  );
};

export default ROWProvisionalFinal;
